import { all } from "redux-saga/effects";
import {
  watchAddGooglePlaceIdToDestination,
  watchCommonBenefitsSaga,
  watchBenefitLookupSaga,
  watchEpcsInitializeSaga,
  watchEpcsStatusSaga,
  watchGetMakeModelSaga,
  watchNearBySearch,
  watchPartnerDetailsSaga,
  watchPepSessionSaga,
  watchSubmitRequestSaga,
  watchUpdateDestinationWithPredictionAddress,
  watchAddMoreNearByDestinations,
  watchIncidentReportFormQuestionsSaga,
  watchChatbotSaga,
  watchSearchVehicleByLicensePlateVinSaga,
  watchSaveRescueDetailsRetrieveResults,
  watchReadyToSubmitRescue,
  watchPredictiveETASaga,
  watchUrlShortenerSaga
} from "./saga";
import {
  watchConfirmDropoffDestinationSaga,
  watchGetCustomAddressDistance,
} from "./screens/DropoffLocationSelection/sagas";
import {
  watchCreateCouponForPep,
  watchGetEnhancedAuthBenefitsSaga,
  watchSubmitOdometerPartialSave,
  watchSubmitCallOemPartialSave,
  watchSubmitDeclinePartialSave,
} from "./features";
import { watchInitSaga } from "./features/FeatureFlags";

const root = function* rootSaga() {
  yield all([
    watchAddMoreNearByDestinations(),
    watchBenefitLookupSaga(),
    watchChatbotSaga(),
    watchCommonBenefitsSaga(),
    watchConfirmDropoffDestinationSaga(),
    watchCreateCouponForPep(),
    watchNearBySearch(),
    watchUpdateDestinationWithPredictionAddress(),
    watchAddGooglePlaceIdToDestination(),
    watchGetMakeModelSaga(),
    watchSubmitRequestSaga(),
    watchPartnerDetailsSaga(),
    watchEpcsInitializeSaga(),
    watchEpcsStatusSaga(),
    watchPepSessionSaga(),
    watchIncidentReportFormQuestionsSaga(),
    watchInitSaga(),
    watchGetCustomAddressDistance(),
    watchGetEnhancedAuthBenefitsSaga(),
    watchSearchVehicleByLicensePlateVinSaga(),
    watchSaveRescueDetailsRetrieveResults(),
    watchReadyToSubmitRescue(),
    watchPredictiveETASaga(),
    watchUrlShortenerSaga(),
    watchSubmitOdometerPartialSave(),
    watchSubmitCallOemPartialSave(),
    watchSubmitDeclinePartialSave()
  ]);
};

export function initSagas(sagaMiddleWare) {
  sagaMiddleWare.run(root);
}
